"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FormatNotValidException extends Error {
    constructor(format, formats) {
        super(`Il formato '${format}' non è valido. I formati supportati sono: ${formats.join(', ')}`);
    }
}
exports.FormatNotValidException = FormatNotValidException;
class ColorNotFoundException extends Error {
    constructor(id) {
        super(`Il colore con id '${id}' non è stato trovato`);
    }
}
exports.ColorNotFoundException = ColorNotFoundException;
class TagNotFoundException extends Error {
    constructor(tag) {
        super(`il tag '${tag}' non è stato trovato.`);
    }
}
exports.TagNotFoundException = TagNotFoundException;
//# sourceMappingURL=PaletteExceptions.js.map